import { render, staticRenderFns } from "./ViewMoreOrLess.vue?vue&type=template&id=95818eb8&"
import script from "./ViewMoreOrLess.vue?vue&type=script&lang=js&"
export * from "./ViewMoreOrLess.vue?vue&type=script&lang=js&"
import style0 from "./ViewMoreOrLess.vue?vue&type=style&index=0&id=95818eb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports